import { List, Record } from "immutable";

import { type TFilterType } from "./AccessReviewTemplateModel";

const defaults = {
  filterType: "exclude" as TFilterType,
  id: "",
  integrationId: "",
  integrationResourceId: "",
  roleIds: List<string>(),
};

type TAccessReviewTemplateResourceRuleModel = typeof defaults;

export class AccessReviewTemplateResourceRuleModel extends Record<TAccessReviewTemplateResourceRuleModel>(defaults) {
  static fromServerData(data: unknown): AccessReviewTemplateResourceRuleModel {
    const { filterType, id, integrationId, integrationResourceId, roleIds } =
      data as TAccessReviewTemplateResourceRuleModel;
    return new AccessReviewTemplateResourceRuleModel({
      filterType,
      id,
      integrationId,
      integrationResourceId,
      roleIds: List(roleIds),
    });
  }
}
